import {createTheme, LinkProps, ThemeProvider} from "@mui/material";
import {blue, red} from "@mui/material/colors";
import React, {PropsWithChildren} from "react";
import {Link} from "react-router-dom";

import {useSelector} from "react-redux";
import {RootState} from "store";

const LinkBehavior = React.forwardRef<any,
    Omit<LinkProps, 'to'> & { href: LinkProps['to'] }>((props, ref) => {
    const {href, ...other} = props;
    // Map href (MUI) -> to (react-router)
    return <Link ref={ref} to={href} {...other} />;
});


let theme = createTheme({
    palette: {
        primary: {
            main: blue[400],
        },
        secondary: {
            main: red[500]
        }
    },
    components: {
        MuiLink: {
            defaultProps: {
                // @ts-ignore
                component: LinkBehavior,
            },
        },
        MuiButtonBase: {
            defaultProps: {
                LinkComponent: LinkBehavior,
            },
        },
        MuiCardMedia: {
            styleOverrides: {
                root: {
                    margin: "0.5em",
                }
            }
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    backgroundColor: 'white',
                    border: "unset",
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                variant: "standard"
            }
        },
        MuiFormControl: {
            defaultProps: {
                variant: "standard"
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    minWidth: "50px"
                }
            }
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    justifyContent: "flex-end"
                }
            }
        },
        MuiGrid: {
            defaultProps: {
                spacing: 2,


            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    "&.Mui-selected": {
                        "backgroundColor": "white"
                    }
                }
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    padding: "2em 2em 0",
                    backgroundColor: "white"
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    overflow: "visible"
                }
            }
        },
        MuiPagination: {
            styleOverrides: {
                root: {
                    padding: "2em 0"
                }
            }
        },
        MuiCircularProgress: {
            styleOverrides: {
                root: {
                    marginLeft: "auto",
                    marginRight: "auto"
                }
            }
        },
        MuiTypography: {
            styleOverrides: {
                subtitle1: {
                    marginBottom: 0
                }
            }
        }
    }
});

theme = createTheme(theme, {
    typography: {
        fontFamily: [
            'Roboto',
            'Arial',
            'sans-serif',
        ].join(','),
        h1: {
            fontSize: "2.5em",
        },
        h2: {
            fontSize: "2em",
        },
        h3: {
            fontSize: "1.8em",
        },
        h4: {
            fontSize: "1.6em",
        },
        h5: {
            fontSize: "1.4em",
            paddingBottom: ".5em",
        },
        h6: {
            fontSize: "1.2em",
        },
        subtitle1: {
            fontSize: "0.8rem",
            color: theme.palette.secondary.main
        },
        subtitle2: {
            fontSize: "1.1em",
        },
        body1: {
            fontSize: "1em"
        },
        body2: {
            fontSize: ".8em"
        }
    }
})


export default (props: PropsWithChildren) => {
    const mode = useSelector<RootState, "light" | "dark">(state => state.sessionState.themeMode);
    return <ThemeProvider theme={mode === "light" ? theme : theme}>
        {props.children}
    </ThemeProvider>
}
